import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { HeaderConfig } from '@urbannex/storethemes';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { IframeCommunicationService } from '../../services/iframe-communication.service';
import { InputField } from '../../model';

export interface HeaderEditorState{
  headerConfigState:HeaderConfig;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderEditorStoreService  extends ComponentStore<HeaderEditorState>{

  constructor(private previewEditStore:PreviewEditStoreService,
    private communicator:IframeCommunicationService,) {
    super({headerConfigState:undefined})
  }

  init(headerConfig:HeaderConfig){
    //console.log(headerConfig);
    this.updateHeaderConfig(headerConfig)
  }
  //updaters
  readonly updateHeaderConfig = this.updater((state:HeaderEditorState,headerConfig:HeaderConfig) => {
    return {
      ...state,
      headerConfigState:headerConfig
    }
  })

  //selectors
  readonly headerConfigState$:Observable<HeaderConfig> = this.select(state => state.headerConfigState);

  //efects

  readonly toggleRow = this.effect<void>(
    trigger$ => trigger$.
    pipe(
      map(() => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          console.log(headerConfig.bottomHeader)          
        })
      })
    )
  )

  readonly toggleHeaderRow = this.effect((row$:Observable<string>) => {
    return row$.pipe(
      tap((row:string) => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          if(row == "topHeader"){
            headerConfig.topHeader = !headerConfig.topHeader;
            this.updateHeaderConfig(headerConfig);
          }else if(row == "bottomHeader"){
            headerConfig.bottomHeader = !headerConfig.bottomHeader;
            this.updateHeaderConfig(headerConfig);
          }
          //console.log(headerConfig.bottomHeader)          
        })
        this.headerConfigState$.subscribe(data => {
          this.previewEditStore.updateSiteHeader(data)
        })
        this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
          console.log("Sending HeaderConfig")
          this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
        })
      })
    )
   })

   readonly updateSiteName = this.effect((siteName$:Observable<string>) => {
    return siteName$.pipe(
      tap((siteName:string) => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          headerConfig.mainHeaderConfig.logoNavConfig.storeName = siteName;
          this.updateHeaderConfig(headerConfig);
        })
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          this.previewEditStore.updateSiteHeader(headerConfig)
        })
        this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
          console.log("Sending HeaderConfig")
          this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
        })
      })
    )
   })

   readonly updateShowStoreName = this.effect((showStoreName$:Observable<boolean>) => {
    return showStoreName$.pipe(
      tap((showStoreName:boolean) => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          headerConfig.mainHeaderConfig.logoNavConfig.showStoreName = showStoreName;
          this.updateHeaderConfig(headerConfig);
        })
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          this.previewEditStore.updateSiteHeader(headerConfig)
        })
        this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
          console.log("Sending HeaderConfig")
          this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
        })
      })
    )
   })

   readonly updateHeaderTheme = this.effect((field$:Observable<InputField>) => {
    return field$.pipe(
      tap((field:InputField) => {
        console.log(field)
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          let themeEnum = field.value;
          switch (field.context["cellId"]){
            case "main":
              headerConfig.mainHeaderConfig.themeEnum = themeEnum;
              break;
            case "top":
              headerConfig.topHeaderConfig.themeEnum = themeEnum;
              break;
            case "bottom":
              headerConfig.bottomHeaderConfig.themeEnum = themeEnum;
              break;
            default:
              break;
          }
          this.updateHeaderConfig(headerConfig);
          this.previewEditStore.updateSiteHeader(headerConfig);
          this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
            console.log("Sending HeaderConfig")
            this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
          })
        })
        /* this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          this.previewEditStore.updateSiteHeader(headerConfig)
        }) */
        /* this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
          console.log("Sending HeaderConfig")
          this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
        }) */
      })
    )
   })

   //this.headerStore.updateHeaderCustom(field.cellId,field.value)
   readonly updateHeaderCustom = this.effect((field$:Observable<InputField>) => {
    return field$.pipe(
      tap((field:InputField) => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          switch (field.context["cellId"]) {
            case "main":
              console.log(field);
              headerConfig.mainHeaderConfig.themeEnum = field.value;
              break;
            case "top":
              headerConfig.topHeaderConfig.themeEnum = field.value;
              break;
            case "bottom":
              headerConfig.bottomHeaderConfig.themeEnum = field.value;
              break;
            default:
              break;
          }
          this.updateHeaderConfig(headerConfig);
          this.previewEditStore.updateSiteHeader(headerConfig);
          this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
            console.log("Sending HeaderConfig")
            this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
          })
        })
      })
    )
   })

   readonly updateHeaderBackground = this.effect((field$:Observable<InputField>) => {
    return field$.pipe(
      tap((field:InputField) => {
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          switch (field.context["cellId"]) {
            case "main":
              headerConfig.mainHeaderConfig.background = field.value;
              break;
            case "top":
              headerConfig.topHeaderConfig.background = field.value;
              break;
            case "bottom":
              headerConfig.bottomHeaderConfig.background = field.value;
              break;
          
            default:
              break;
          }
          this.updateHeaderConfig(headerConfig);
          this.previewEditStore.updateSiteHeader(headerConfig);
          this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
            console.log("Sending HeaderConfig")
            this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
          })
        })
      })
    )
   })

   readonly updateHeaderColor = this.effect((field$:Observable<InputField>) => {
    return field$.pipe(
      tap((field:InputField) => {
        console.log(field)
        this.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
          switch (field.context["cellId"]) {
            case "main":
              headerConfig.mainHeaderConfig.color = field.value;
              break;
            case "top":
              headerConfig.topHeaderConfig.color = field.value;
              break;
            case "bottom":
              headerConfig.bottomHeaderConfig.color = field.value;
              break;
          
            default:
              break;
          }
          this.updateHeaderConfig(headerConfig);
          this.previewEditStore.updateSiteHeader(headerConfig);
          this.previewEditStore.siteEditorSitesState$.subscribe(sites => {
            console.log("Sending HeaderConfig")
            this.communicator.sendFromParent(({id:"headerConfig","data":sites[0].siteHeader}))
          })
        })
      })
    )
   })
   /* loadConfig = this.effect<void>(
    trigger$ => trigger$.
    pipe(
      map(() => {
        console.log("tapping")
        this.siteConfigListenerService.initSiteEditorConfig()
          .subscribe((siteEditorConfig) => {
            console.log(siteEditorConfig)
            this.updateSiteEditorConfigState(siteEditorConfig)
            this.testUpdate();
          })
      })
    )
  ) */


}
